import { createActionGroup, props } from '@ngrx/store';
import { Visit, CreateVisitDto, RecordVisitDto } from '../../models/visit.model';

export const VisitActions = createActionGroup({
  source: 'Visit',
  events: {
    'Load Visits': props<{ orderId?: number; workOrderId?: number }>(),
    'Load Visits Success': props<{ visits: Visit[] }>(),
    'Load Visits Failure': props<{ error: string }>(),
    'Load Visit': props<{ id: number }>(),
    'Load Visit Success': props<{ visit: Visit }>(),
    'Create Visit': props<{ dto: CreateVisitDto }>(),
    'Create Visit Success': props<{ visit: Visit }>(),
    'Start Visit': props<{ id: number }>(),
    'Start Visit Success': props<{ visit: Visit }>(),
    'Complete Visit': props<{ id: number; dto: RecordVisitDto }>(),
    'Complete Visit Success': props<{ visit: Visit }>(),
    'Cancel Visit': props<{ id: number }>(),
    'Cancel Visit Success': props<{ visit: Visit }>(),
    'Skip Visit': props<{ id: number; reason?: string }>(),
    'Skip Visit Success': props<{ visit: Visit }>(),
    'Visit Failure': props<{ error: string }>(),
  }
});
